export const translations = {
  en: {
    nav: {
      services: 'Services',
      portfolio: 'Portfolio',
      benefits: 'Benefits',
      contact: 'Contact',
      getStarted: 'Get Started'
    },
    hero: {
      badge: 'Powered by AI',
      title1: 'Use',
      title2: 'Technology',
      title3: 'As Your Growth Engine',
      description: 'Reduce operational costs by',
      description2: 'while scaling exponentially. Enterprise AI consulting for ambitious companies.',
      cta1: 'Schedule Consultation',
      cta2: 'View Case Studies',
      stats: {
        clients: 'Clients',
        savings: 'Savings',
        roi: 'ROI'
      },
      features: {
        aiPowered: { title: 'AI-Powered', desc: 'Cutting-edge intelligence' },
        fastResults: { title: 'Fast Results', desc: '2-12 months ROI' },
        enterprise: { title: 'Enterprise Grade', desc: 'SME, Mid-cap, Large Enterprise' },
        global: { title: 'Global Scale', desc: 'Worldwide deployment' }
      }
    },
    services: {
      badge: 'Our Expertise',
      title: 'Comprehensive AI Solutions',
      subtitle: 'Services designed to accelerate transformation',
      learnMore: 'Learn More',
      items: [
        {
          title: ' Business Ops Automation',
          description: 'Streamline repetitive tasks, optimize workflows, and reduce operational costs by implementing intelligent automation solutions tailored to your business processes.'
        },
        {
          title: 'AI Formation for Business',
          description: 'Empower your team with cutting-edge AI knowledge. Comprehensive training programs designed to help your organization leverage AI effectively and stay competitive.'
        },
        {
          title: 'Software Performance Audit',
          description: 'In-depth analysis of your software systems to identify bottlenecks, optimize performance, and ensure scalability. Get actionable insights to maximize efficiency.'
        }
      ]
    },
    portfolio: {
      badge: 'Success Stories',
      title: 'Real Impact, Real Results',
      subtitle: 'Transforming businesses with measurable outcomes',
      impact: 'Impact',
      solution: 'Solution'
    },
    benefits: {
      badge: 'Why Choose Us',
      title: 'The AI Advantage',
      subtitle: 'Measurable ROI through intelligent automation',
      roi: '300-500% ROI',
      roiDesc: 'Most clients see positive returns within',
      roiTime: '6-12 months',
      items: [
        {
          title: 'Reduce Labor Costs',
          description: 'Automate repetitive tasks and free up your team to focus on high-value strategic work that drives growth.'
        },
        {
          title: 'Scale Without Hiring',
          description: 'Handle 10x more workload with AI-powered systems that work 24/7 without additional headcount.'
        },
        {
          title: 'Eliminate Human Error',
          description: 'AI systems ensure consistent accuracy in data processing, reducing costly mistakes and rework.'
        },
        {
          title: 'Faster Time to Market',
          description: 'Accelerate development cycles and launch products faster with optimized engineering processes.'
        },
        {
          title: 'Competitive Advantage',
          description: 'Stay ahead of competitors by leveraging cutting-edge AI technology before it becomes mainstream.'
        },
        {
          title: 'Data-Driven Insights',
          description: 'Make better business decisions with AI-powered analytics that reveal hidden patterns and opportunities.'
        }
      ]
    },
    contact: {
      badge: 'Get In Touch',
      title: 'Start Your Transformation',
      subtitle: "Let's discuss how AI can accelerate your growth",
      description: 'Book a free 30-minute consultation to explore how AI can transform your business operations and drive measurable results.',
      cta: 'Book Your Free Consultation',
      features: [
        'Free 30-minute strategy session',
        'Personalized AI implementation roadmap',
        'ROI analysis and cost-benefit breakdown',
        'Q&A with our AI experts'
      ]
    },
    footer: {
      description: 'AI Consulting and Software Engineering specialists helping businesses achieve exponential growth through intelligent automation.',
      quickLinks: 'Quick Links',
      services: 'Services',
      servicesItems: ['AI Automation', 'AI Training', 'Performance Audit'],
      copyright: '© 2025 Startandgrowth. All rights reserved. Engineered for the future.'
    },
    event: {
      badge: 'Exclusive Event',
      title: 'AI FACTORY',
      subtitle: 'FEBRUARY 2026 - COTONOU',
      tagline: 'How using AI can contribute to company growth',
      description: 'An exclusive afterwork to discuss about AI Impact on economic growth',
      cta: 'Learn More',
      teaser: {
        title: 'Join Us at AI FACTORY',
        description: 'Discover how AI is shaping the future of African digital sovereignty',
        date: 'Cotonou 2026'
      }
    },
    eventPage: {
      backToHome: 'Back to Home',
      hero: {
        badge: 'Exclusive Event',
        title: 'AI FACTORY: 18 FEB 2026',
        subtitle: 'Artificial Intelligence for company growth',
        description: 'An exclusive afterwork to discuss about AI Impact on economic growth',
        format: 'Format: Strategic Afterwork | Location: To be confirmed (TBC) | Time: 18h - 20h30 | Target: Executives & Tech Talents'
      },
      why: {
        title: 'Why AI Factory?',
        intro: 'Africa must no longer just be a consumer, but an architect of its own digital revolution. To build tomorrow\'s champions (our future African Numeric GIANTS), three levers are essential:',
        points: [
          {
            title: 'Scalability',
            desc: 'Go beyond digital craftsmanship thanks to DevOps and cutting-edge architectures to support massive growth.'
          },
          {
            title: 'Performance',
            desc: 'Use the latest Engineering & AI tools to transform data into real profit and precision efficiency.'
          },
          {
            title: 'Sovereignty',
            desc: 'Mastering the tools of tomorrow to guarantee our independence today.'
          }
        ]
      },
      program: {
        title: '2.5 hours to change perspective',
        intro: 'The event is designed to be a condensed mix of inspiration and pragmatism.',
        items: [
          {
            icon: '⚡',
            title: 'Lightning Talk (1 hour)',
            points: [
              'AI & ROI: How AI concretely boosts revenue.',
              'Demos: Use cases adapted to the Beninese market.',
              'Sovereignty: Infrastructure and Cloud, the foundations of freedom.'
            ]
          },
          {
            icon: '🤝',
            title: 'Selective Networking',
            points: [
              'Connecting execs, institutions and experts.'
            ]
          },
          /*{
            icon: '🎙️',
            title: '"Future of Africa" Capsules',
            points: [
              'Live podcast recording to document the vision of tech leaders present.'
            ]
          }*/
        ]
      },
      benefits: {
        title: 'What you will gain ?',
        decision: {
          title: 'For Executives (C-levels)',
          items: [
            'Understand the real ROI of AI.',
            'Identify cost reduction levers.',
            'Access a network of qualified experts.'
          ]
        },
        experts: {
          title: 'For Experts (Tech Talents)',
          items: [
            'Discover international standards.',
            'Exchange on local challenges.',
            'Contribute to the country\'s sovereignty.'
          ]
        }
      },
      initiator: {
        title: 'Orga,',
        subtitle: 'International expertise serving local needs',
        name: 'Aros FONTON',
        bio: 'Software Engineer and AI Consultant, he supports companies in their transformation towards highly scalable systems. Active member of the diaspora committed to the emergence of African tech champions.'
      },
      ecosystem: {
        title: 'Ecosystem & Synergies',
        subtitle: 'A collective dynamic',
        intro: 'This event aspires to federate the ecosystem\'s vital forces:',
        items: [
          'Local developer communities.',
          'Digital entrepreneurship support networks.',
          'SME promotion and investment institutions.'
        ],
        note: '(Currently being structured with major sector players).'
      },
      cta: {
        title: 'Stay informed or join the adventure',
        subtitle: 'Would you like to participate, become a partner, or speak?'
      }
    },
    assistant: {
      badge: 'AI Assistant',
      title: 'Project Requirements Assistant',
      subtitle: 'Tell us about your project and we\'ll help you define the specifications',
      backToHome: 'Back to Home',
      inputPlaceholder: 'Type your message...',
      contactTitle: 'Almost there! Enter your contact details to receive your specifications',
      namePlaceholder: 'Your name *',
      emailPlaceholder: 'Your email *',
      companyPlaceholder: 'Company name',
      phonePlaceholder: 'Phone number',
      generateAndSend: 'Generate & Send Specifications',
      generating: 'Generating specifications...',
      specsTitle: 'Your Project Specifications',
      newConversation: 'Start New Conversation',
      specsEmailSent: 'Your specifications have been generated and sent to {email}!',
      specsGenerated: 'Your specifications have been generated!',
      errorStarting: 'Sorry, I couldn\'t start the session. Please refresh the page.',
      errorSending: 'Sorry, I couldn\'t process your message. Please try again.',
      errorGenerating: 'Sorry, there was an error generating your specifications. Please try again.'
    },
    aiFactoryPage: {
      badge: '2026 Program',
      title: 'AI FACTORY',
      subtitle: 'Transforming AI into a competitiveness lever for African companies. Exclusive program supporting West African SME leaders and managers in concrete AI adoption.',
      cta1: 'Become a Partner',
      stats: [
        { value: '4', label: 'Countries Covered' },
        { value: '200+', label: 'Afterwork Registrations' },
        { value: '2K+', label: 'Network Followers' },
        { value: '10+', label: 'Active Partners' }
      ],
      aboutTitle: 'About the Program',
      aboutDescription: 'AI Factory supports West African SME leaders and managers each month in the concrete adoption of AI. Exclusive format for 10 selected participants, with invited AI experts and actionable use cases.',
      featuresTitle: 'Key Features',
      features: [
        {
          icon: 'users',
          title: 'Exclusive Format',
          description: '10 selected participants per edition to ensure personalized support and quality exchanges.'
        },
        {
          icon: 'brain',
          title: 'Invited AI Experts',
          description: 'Leading speakers and demonstrations of real AI solutions used in Africa.'
        },
        {
          icon: 'rocket',
          title: 'Actionable Use Cases',
          description: 'Focus on concrete applications you can implement immediately in your business.'
        }
      ],
      roadmapTitle: '2026 Roadmap',
      roadmap: [
        {
          icon: 'calendar',
          title: 'June - Webinar #1',
          description: 'AI for Project Management: optimize your planning, resources and project tracking.'
        },
        {
          icon: 'video',
          title: 'July - Webinar #2',
          description: 'AI for Sales: automate your sales processes and improve conversion rates.'
        },
        {
          icon: 'video',
          title: 'August - Webinar #3',
          description: 'AI for HR & Recruitment: transform your talent management with AI.'
        },
        {
          icon: 'video',
          title: 'September - Webinar #4',
          description: 'AI for Customer Service: deliver exceptional customer experience with AI.'
        },
        {
          icon: 'book',
          title: 'Workshops & Bootcamps',
          description: 'In-depth sessions to master specific tools based on program traction.'
        },
        {
          icon: 'globe',
          title: 'International Conferences',
          description: 'Meet with international AI suppliers and experts.'
        }
      ],
      benefitsTitle: 'Win-Win Partnership',
      benefitsSubtitle: 'No financial commitment, no operational constraint. Enrich your community with AI content they won\'t find anywhere else in West Africa.',
      contributeTitle: 'What you contribute',
      contribute: [
        'Relay the program to your members',
        '1 referent contact for participant selection',
        'Presence at our launch events'
      ],
      receiveTitle: 'What you receive',
      receive: [
        'Logo on all AI Factory communication materials',
        'Priority reserved places for your members',
        'Ready-to-use AI content to engage your community',
        'Association with the AI Factory ecosystem throughout 2026'
      ],
      partnersTitle: 'Supported by',
      partners: [
        'CCIB',
        'GDG Abomey-Calavi',
        '10 000 Codeurs',
        'HUB',
        'Afropoles Incubator',
        'Indabax Benin',
        'NSIA Asset Mgmt',
        'DualForce Capital',
        'BUBO',
        'DIA Advisory'
      ],
      ctaTitle: 'Join the AI Factory Ecosystem',
      ctaDescription: 'Become a partner and help us make AI accessible to West African businesses. Together, let\'s transform AI into a true competitive advantage.',
      ctaEmail: 'Contact Us',
      ctaBackHome: 'Back Home',
      footerTagline: 'AI Consulting & Software Engineering for West Africa'
    }
  },
  fr: {
    nav: {
      services: 'Services',
      portfolio: 'Portfolio',
      benefits: 'Avantages',
      contact: 'Contact',
      getStarted: 'Commencer'
    },
    hero: {
      badge: 'Propulsé par IA',
      title1: 'Utilisez',
      title2: 'la technologie',
      title3: 'comme moteur de croissance',
      description: 'Réduisez les coûts opérationnels de',
      description2: 'tout en augmentant la productivité de manière exponentielle. Conseil en IA d\'entreprise pour les sociétés ambitieuses.',
      cta1: 'Planifier une Consultation',
      cta2: 'Voir les Études de Cas',
      stats: {
        clients: 'Clients',
        savings: 'Économies',
        roi: 'ROI'
      },
      features: {
        aiPowered: { title: 'Propulsé par IA', desc: 'Intelligence de pointe' },
        fastResults: { title: 'Résultats Rapides', desc: 'ROI en 2-6 mois' },
        enterprise: { title: 'Niveau Entreprise', desc: 'PME, ETI, Grande Entreprise' },
        global: { title: 'Échelle Mondiale', desc: 'Déploiement mondial' }
      }
    },
    services: {
      badge: 'Notre Expertise',
      title: 'Solutions IA Complètes',
      subtitle: 'Services conçus pour accélérer la transformation',
      learnMore: 'En Savoir Plus',
      items: [
        {
          title: 'Automatisation des Opérations Commerciales',
          description: 'Rationalisez les tâches répétitives, optimisez les flux de travail et réduisez les coûts opérationnels en implémentant des solutions d\'automatisation intelligente adaptées à vos processus métier.'
        },
        {
          title: 'Formation en IA pour les Entreprises',
          description: 'Donnez à votre équipe les connaissances IA de pointe. Programmes de formation complets conçus pour aider votre organisation à tirer parti de l\'IA efficacement et rester compétitive.'
        },
        {
          title: 'Audit de Performance Logicielle',
          description: 'Analyse approfondie de vos systèmes logiciels pour identifier les goulots d\'étranglement, optimiser les performances et assurer l\'évolutivité. Obtenez des informations exploitables pour maximiser l\'efficacité.'
        }
      ]
    },
    portfolio: {
      badge: 'Success Stories',
      title: 'Impact Réel, Résultats Réels',
      subtitle: 'Transformer les entreprises avec des résultats mesurables',
      impact: 'Impact',
      solution: 'Solution'
    },
    benefits: {
      badge: 'Pourquoi Nous Choisir',
      title: 'L\'Avantage IA',
      subtitle: 'ROI mesurable grâce à l\'automatisation intelligente',
      roi: '300-500% ROI',
      roiDesc: 'La plupart des clients voient des rendements positifs en',
      roiTime: '6-12 mois',
      items: [
        {
          title: 'Réduire les Coûts de Main-d\'Œuvre',
          description: 'Automatisez les tâches répétitives et libérez votre équipe pour se concentrer sur un travail stratégique à haute valeur ajoutée qui stimule la croissance.'
        },
        {
          title: 'Évoluer Sans Embaucher',
          description: 'Gérez 10 fois plus de charge de travail avec des systèmes alimentés par l\'IA qui fonctionnent 24h/24 et 7j/7 sans effectif supplémentaire.'
        },
        {
          title: 'Éliminer les Erreurs Humaines',
          description: 'Les systèmes IA assurent une précision constante dans le traitement des données, réduisant les erreurs coûteuses et le retravail.'
        },
        {
          title: 'Délai de Mise sur le Marché Plus Rapide',
          description: 'Accélérez les cycles de développement et lancez des produits plus rapidement avec des processus d\'ingénierie optimisés.'
        },
        {
          title: 'Avantage Concurrentiel',
          description: 'Gardez une longueur d\'avance sur la concurrence en exploitant la technologie IA de pointe avant qu\'elle ne devienne courante.'
        },
        {
          title: 'Informations Basées sur les Données',
          description: 'Prenez de meilleures décisions commerciales avec des analyses alimentées par l\'IA qui révèlent des modèles et des opportunités cachés.'
        }
      ]
    },
    contact: {
      badge: 'Contactez-Nous',
      title: 'Commencez Votre Transformation',
      subtitle: 'Discutons de la façon dont l\'IA peut accélérer votre croissance',
      description: 'Réservez une consultation gratuite de 30 minutes pour explorer comment l\'IA peut transformer vos opérations commerciales et générer des résultats mesurables.',
      cta: 'Réserver Votre Consultation Gratuite',
      features: [
        'Session stratégique gratuite de 30 minutes',
        'Feuille de route personnalisée d\'implémentation IA',
        'Analyse ROI et répartition coûts-avantages',
        'Q&R avec nos experts en IA'
      ]
    },
    footer: {
      description: 'Spécialistes du conseil en IA et de l\'ingénierie logicielle aidant les entreprises à atteindre une croissance exponentielle grâce à l\'automatisation intelligente.',
      quickLinks: 'Liens Rapides',
      services: 'Services',
      servicesItems: ['Automatisation IA', 'Formation IA', 'Audit de Performance'],
      copyright: '© 2025 Startandgrowth. Tous droits réservés. Conçu pour l\'avenir.'
    },
    event: {
      badge: 'Événement Exclusif',
      title: 'AI FACTORY',
      subtitle: '18 FEV 2026',
      tagline: 'L\'intelligence artificielle au service de la croissance des entreprises.',
      description: 'Un afterwork exclusif pour connecter la tech à la croissance économique.',
      cta: 'En Savoir Plus',
      teaser: {
        title: 'Rejoignez-nous à AI FACTORY',
        description: 'Découvrez comment l\'IA façonne l\'avenir de la souveraineté numérique africaine',
        date: 'Cotonou 2026'
      }
    },
    eventPage: {
      backToHome: 'Retour à l\'Accueil',
      hero: {
        badge: 'Événement Exclusif',
        title: 'AI FACTORY : 18 FEV 2026',
        subtitle: 'L\'Intelligence artificielle au service de la croissance des entreprises',
        description: 'Un afterwork exclusif pour connecter l\'expertise technique à la croissance économique.',
        format: 'Format : Afterwork Stratégique | Lieu exact communiqué prochainement | Heure : 18h - 20h30 | Cible : Décideurs & Talents Tech'
      },
      why: {
        title: 'Pourquoi AI Factory ?',
        intro: 'L\'Afrique ne doit plus seulement être consommatrice, mais architecte de sa révolution numérique. Pour bâtir les champions de demain (nos futurs géants du numérique Africain), trois leviers sont indispensables :',
        points: [
          {
            title: 'La Scalabilité',
            desc: 'Passer de l\'artisanat au aux architectures de pointe pour supporter une croissance massive.'
          },
          {
            title: 'La Performance',
            desc: 'Utiliser les derniers outils d\'Engineering & AI pour transformer la donnée en profit réel et en efficacité millimétrée.'
          },
          {
            title: 'La Souveraineté',
            desc: 'Maîtriser les outils de demain pour garantir notre indépendance dès aujourd\'hui.'
          }
        ]
      },
      program: {
        title: '2h30 pour changer de perspective',
        intro: 'L\'événement est conçu pour être un condensé d\'inspiration et de pragmatisme.',
        items: [
          {
            icon: '⚡',
            title: 'Lightning Talk (1 hr)',
            points: [
              'IA & ROI : Comment l\'IA booste concrètement le chiffre d\'affaires.',
              'Démos : Cas d\'usages adaptés au marché béninois.',
              'Souveraineté : Infrastructures et Cloud, les bases de la liberté.'
            ]
          },
          {
            icon: '🤝',
            title: 'Networking Sélectif',
            points: [
              'Mise en relation entre porteurs de projets, institutions et experts autour d\'un cocktail dinatoire.'
            ]
          },
          /*{
            icon: '🎙️',
            title: 'Capsules "Future of Africa"',
            points: [
              'Enregistrement de podcasts live pour documenter la vision des leaders tech présents.'
            ]
          }*/
        ]
      },
      benefits: {
        title: 'Ce que vous allez en retirer',
        decision: {
          title: 'Pour les Décideurs (C-levels)',
          items: [
            'Comprendre le ROI réel de l\'IA.',
            'Identifier les leviers de réduction de coûts.',
            'Accéder à un réseau d\'experts qualifiés.'
          ]
        },
        experts: {
          title: 'Pour les Experts (Talents Tech)',
          items: [
            'Découvrir les standards internationaux.',
            'Échanger sur les enjeux de la data.',
            'Contribuer à la souveraineté du pays.'
          ]
        }
      },
      initiator: {
        title: 'Organisé par',
        subtitle: 'Une expertise internationale au service de l\'écosytème local',
        name: 'Aros FONTON',
        bio: ' Référent IA 10 000 Codeurs et Ingénieur Informatique, il accompagne les entreprises dans leur transformation vers des systèmes hautement scalables. Membre actif de la diaspora engagé pour l\'éclosion de champions tech africains.'
      },
      ecosystem: {
        title: 'Écosystème & Synergies',
        subtitle: 'Une dynamique collective',
        intro: 'Cet événement aspire à fédérer les forces vives de l\'écosystème :',
        items: [
          'Les communautés tech locales.',
          'Les réseaux d\'accompagnement à l\'entrepreneuriat numérique.',
          'Les institutions de promotion des entreprises.'
        ],
        note: '(En cours de structuration avec les acteurs majeurs du secteur).'
      },
      cta: {
        title: 'Restez informés ou rejoignez l\'aventure',
        subtitle: 'Vous souhaitez participer, devenir partenaire ou intervenir ?'
      }
    },
    assistant: {
      badge: 'Assistant IA',
      title: 'Assistant Cahier des Charges',
      subtitle: 'Parlez-nous de votre projet et nous vous aiderons à définir les spécifications',
      backToHome: 'Retour à l\'Accueil',
      inputPlaceholder: 'Tapez votre message...',
      contactTitle: 'Presque terminé ! Entrez vos coordonnées pour recevoir vos spécifications',
      namePlaceholder: 'Votre nom *',
      emailPlaceholder: 'Votre email *',
      companyPlaceholder: 'Nom de l\'entreprise',
      phonePlaceholder: 'Numéro de téléphone',
      generateAndSend: 'Générer et Envoyer les Spécifications',
      generating: 'Génération des spécifications...',
      specsTitle: 'Vos Spécifications de Projet',
      newConversation: 'Nouvelle Conversation',
      specsEmailSent: 'Vos spécifications ont été générées et envoyées à {email} !',
      specsGenerated: 'Vos spécifications ont été générées !',
      errorStarting: 'Désolé, je n\'ai pas pu démarrer la session. Veuillez rafraîchir la page.',
      errorSending: 'Désolé, je n\'ai pas pu traiter votre message. Veuillez réessayer.',
      errorGenerating: 'Désolé, une erreur s\'est produite lors de la génération de vos spécifications. Veuillez réessayer.'
    },
    aiFactoryPage: {
      badge: 'Programme 2026',
      title: 'AI FACTORY',
      subtitle: 'Transformer l\'IA en levier de compétitivité pour les entreprises africaines. Programme exclusif qui accompagne les dirigeants et managers de PME d\'Afrique de l\'Ouest dans l\'adoption concrète de l\'IA.',
      cta1: 'Devenir Partenaire',
      stats: [
        { value: '4', label: 'Pays Couverts' },
        { value: '200+', label: 'Inscrits Afterwork' },
        { value: '2K+', label: 'Abonnés Réseaux' },
        { value: '10+', label: 'Partenaires Actifs' }
      ],
      aboutTitle: 'À Propos du Programme',
      aboutDescription: 'AI Factory accompagne chaque mois des dirigeants et managers de PME d\'Afrique de l\'Ouest dans l\'adoption concrète de l\'IA. Format exclusif à 10 participants sélectionnés, avec des experts IA invités et des cas d\'usage actionnables.',
      featuresTitle: 'Les Points Clés',
      features: [
        {
          icon: 'users',
          title: 'Format Exclusif',
          description: '10 participants sélectionnés par édition pour garantir un accompagnement personnalisé et des échanges de qualité.'
        },
        {
          icon: 'brain',
          title: 'Experts IA Invités',
          description: 'Intervenants de premier plan et démonstrations de solutions IA réelles utilisées en Afrique.'
        },
        {
          icon: 'rocket',
          title: 'Cas d\'Usage Actionnables',
          description: 'Focus sur des applications concrètes que vous pouvez implémenter immédiatement dans votre entreprise.'
        }
      ],
      roadmapTitle: 'Roadmap 2026',
      roadmap: [
        {
          icon: 'calendar',
          title: 'Juin - Webinaire #1',
          description: 'L\'IA pour la Gestion de Projet : optimisez votre planning, vos ressources et votre suivi de projets.'
        },
        {
          icon: 'video',
          title: 'Juillet - Webinaire #2',
          description: 'L\'IA pour les Ventes : automatisez vos processus commerciaux et améliorez vos taux de conversion.'
        },
        {
          icon: 'video',
          title: 'Août - Webinaire #3',
          description: 'L\'IA pour le RH & Recrutement : transformez votre gestion des talents avec l\'IA.'
        },
        {
          icon: 'video',
          title: 'Septembre - Webinaire #4',
          description: 'L\'IA pour le Service Client : offrez une expérience client exceptionnelle grâce à l\'IA.'
        },
        {
          icon: 'book',
          title: 'Workshops & Bootcamps',
          description: 'Sessions approfondies pour maîtriser des outils spécifiques selon la traction du programme.'
        },
        {
          icon: 'globe',
          title: 'Conférences Internationales',
          description: 'Rencontres avec des fournisseurs et experts internationaux de l\'IA.'
        }
      ],
      benefitsTitle: 'Partenariat Gagnant-Gagnant',
      benefitsSubtitle: 'Aucun engagement financier, aucune contrainte opérationnelle. Enrichissez votre communauté avec du contenu IA qu\'elle ne trouve nulle part ailleurs en Afrique de l\'Ouest.',
      contributeTitle: 'Ce que vous apportez',
      contribute: [
        'Relais du programme auprès de vos membres',
        '1 contact référent pour la sélection des participants',
        'Présence à nos événements de lancement'
      ],
      receiveTitle: 'Ce que vous recevez',
      receive: [
        'Logo sur tous les supports de communication AI Factory',
        'Places réservées en priorité pour vos membres',
        'Contenu IA clé en main pour animer votre communauté',
        'Association à l\'écosystème AI Factory tout au long de 2026'
      ],
      partnersTitle: 'Soutenu par',
      partners: [
        'CCIB',
        'GDG Abomey-Calavi',
        '10 000 Codeurs',
        'HUB',
        'Afropoles Incubator',
        'Indabax Benin',
        'NSIA Asset Mgmt',
        'DualForce Capital',
        'BUBO',
        'DIA Advisory'
      ],
      ctaTitle: 'Rejoignez l\'Écosystème AI Factory',
      ctaDescription: 'Devenez partenaire et aidez-nous à rendre l\'IA accessible aux entreprises d\'Afrique de l\'Ouest. Ensemble, transformons l\'IA en véritable levier de compétitivité.',
      ctaEmail: 'Nous Contacter',
      ctaBackHome: 'Retour Accueil',
      footerTagline: 'AI Consulting & Software Engineering pour l\'Afrique de l\'Ouest'
    }
  }
};